import Icon from '@/components/Icon';
import MuiDrawer from '@mui/material/Drawer';
import { flexStyle, scrollStyle } from '@themes/mixins';
import styled, { css } from 'styled-components';

import { SvgWrapper } from '../Icon/styles';

export const Root = styled.div``;
export const StyledDrawer = styled(MuiDrawer)<{ $isSideBarOpen: boolean }>`
  flex-shrink: 0;
  white-space: nowrap;
  box-sizing: border-box;

  & .MuiDrawer-paper {
    background-color: ${({ theme }) => theme.colors.paper};
    border-right: 1px solid ${({ theme }) => theme.colors.divider};
    width: 75px;
    transition: width 100ms ease;
    overflow-x: hidden;
    ${scrollStyle()}
  }

  & .MuiPaper-elevation {
    ${flexStyle({
      align: 'left',
      justify: 'space-between',
      direction: 'column',
      wrap: 'nowrap',
    })};
  }

  ${({ $isSideBarOpen }) =>
    $isSideBarOpen &&
    css`
      & .MuiDrawer-paper {
        width: 300px;
      }
    `}
`;
export const DrawerHeader = styled.div<{ $isSidebarOpen?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ $isSidebarOpen }) =>
    $isSidebarOpen ? 'space-between' : 'center'};
  padding: ${({ $isSidebarOpen }) =>
    $isSidebarOpen ? '8px 12px 8px 0' : '8px 0'};
  margin: 0;
  height: 48px;
  flex-shrink: 0;
`;
export const ButtonContainer = styled.div<{ $isOpen: boolean }>`
  ${flexStyle({
    align: 'flex-start',
    justify: 'flex-start',
    direction: 'column',
    wrap: 'nowrap',
  })};
  padding: ${({ $isOpen }) => ($isOpen ? '20px 0px 20px 20px' : '5px')};
  gap: 0;
  flex: 1;
  overflow-y: auto;

  /* Hide scrollbar */
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;
export const PinIcon = styled(Icon)<{ isPinned: boolean }>`
  color: ${({ theme, isPinned }) =>
    isPinned ? theme.colors.orange : theme.colors.textSecondary};
  align-self: center;
  transition: transform 0.3s ease;
  cursor: pointer;
`;

export const LogoIcon = styled(Icon)`
  & > ${SvgWrapper} {
    height: auto;
  }
`;
export const HomeLinkContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0;
  padding: 0 0 0 20px;
  cursor: pointer;
`;
export const Divider = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.divider};
  width: 100%;
  margin: 0;
  flex-shrink: 0;
`;

export const OpenpanelIcon = styled(Icon)<{ rotate?: number }>`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.textSecondary};

  &:hover {
    background-color: ${({ theme }) => theme.colors.secondaryBackground};
    border-radius: 5px;
  }
`;

export const CollapsedHexIcon = styled(Icon)`
  & > ${SvgWrapper} {
    height: auto;
  }
  transition: opacity 0.15s ease;
`;

export const ExpandHintIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 0.15s ease;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const CollapsedLogoButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  padding: 0 6px;
  position: relative;

  &:hover {
    background-color: ${({ theme }) => theme.colors.secondaryBackground};
  }

  &:hover ${CollapsedHexIcon} {
    opacity: 0.2;
  }

  &:hover ${ExpandHintIcon} {
    opacity: 1;
  }
`;

export const FooterContainer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.divider};
  padding: 8px 0;
`;
